/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createReorderOrderStatusesResponseFromDiscriminatorValue, serializeReorderOrderStatusesRequest, serializeReorderOrderStatusesResponse, type ErrorResponse, type ReorderOrderStatusesRequest, type ReorderOrderStatusesResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-statuses/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges the organization's order statuses. Position is meaningful: the first item is the status new orders are submitted with at checkout. Send every existing status exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderOrderStatusesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     put(body: ReorderOrderStatusesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderOrderStatusesResponse | undefined>;
    /**
     * Rearranges the organization's order statuses. Position is meaningful: the first item is the status new orders are submitted with at checkout. Send every existing status exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderOrderStatusesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-statuses/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderOrderStatusesResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderOrderStatusesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
